import { render } from "./IncomeEdit.vue?vue&type=template&id=3f144fa2"
import script from "./IncomeEdit.vue?vue&type=script&lang=js"
export * from "./IncomeEdit.vue?vue&type=script&lang=js"

import exportComponent from "/home/umut/Desktop/tm-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__